import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Modal } from 'app/design-system/components/Modal';

import { closeEmailCollectorDialog } from '../actions';
import { selectShowEmailCollectorDialog } from '../selectors';
import EmailCollectorContent from './EmailCollectorContent';

import styles from './EmailCollector.module.scss';

//TODO Пока что этот функционал отключён, в будущем она понадобится для запуска в другие страны
const EmailCollector = (): JSX.Element => {
  const dispatch = useDispatch();
  const isShow = useSelector(selectShowEmailCollectorDialog);

  const handleClose = useCallback(() => {
    dispatch(closeEmailCollectorDialog());
  }, []);

  return (
    <Modal isOpen={isShow}
           className={styles.mainModal}
           closable
           onClose={handleClose}
           data-test="Modal-EmailCollector">
      <EmailCollectorContent />
    </Modal>
  );
};

export default EmailCollector;
